import React, { Component } from 'react'
import { Trans } from '@lingui/react'
import { connect } from 'react-redux'
import compose from 'lodash/fp/compose'

import errorBoundary from 'client/shared/decorators/error-boundary'

import Spacer from 'client/shared/blocks/spacer'
import List, { HeaderRank } from 'client/bookmate/blocks/list'
import { CardQuoteBox } from 'client/bookmate/boxes/card-quote-box'
import MoreButton from 'client/shared/blocks/more-button'

import { getBookById } from 'client/bookmate/selectors/book-selector'
import { getQuotesByIds } from 'client/bookmate/reducers/quotes-reducer'

import urlFor from 'shared/tools/url-helper'

import { QuoteProps } from 'client/shared/types/quote'
import { ResourceName, ResourceProps } from 'client/shared/types/resource'

type Props = {
  kind: string
  resource: ResourceProps
  quotesIndex: QuoteProps[]
  resourceType: ResourceName
  headerRank: HeaderRank
}

class BookQuotesIndexBox extends Component<Props> {
  render() {
    const {
      quotesIndex,
      resourceType = 'book',
      resource: { uuid },
      headerRank,
    } = this.props

    return (
      <div>
        {quotesIndex.length > 0 && (
          <div>
            <List headerRank={headerRank} header="book.quotes_header">
              {quotesIndex.slice(0, 3).map(quote => (
                <CardQuoteBox as="li" quote={quote} key={quote.uuid} />
              ))}
            </List>
            <Spacer size={24} />
            <MoreButton path={urlFor[`${resourceType}Quotes`](uuid)} centered>
              <Trans id="topic.show_all" />
            </MoreButton>
            <Spacer size={48} />
          </div>
        )}
      </div>
    )
  }
}

const connectWrapper = connect((state, { resourceType = 'book' }) => ({
  quotesIndex: getQuotesByIds(state, state[resourceType].quotesIndex),
  resource: getBookById(state, state[resourceType].uuid),
}))

const wrappers = compose(connectWrapper, errorBoundary)

export default wrappers(BookQuotesIndexBox)
